import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <p className="copyright text-center">
        &copy; Facility Bills {new Date().getFullYear()}
      </p>
    </div>
  </footer>
);

export default Footer;
